<!--
 * @Description  : 自定义页面配置
 * @Author       : ll
 * @Date         : 2025-03-21 09:51:27
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-09-16 15:57:13
 * @FilePath     : \ngs_platform_manage_admin\src\views\website\pageConfiguration\index.vue
-->
<template>
	<div class="settled-enterprises-layout operation-layout pd0">
		<!-- 列表查询页 -->
		<filter-layout @search="searchResult" @reset="resetForm" v-if="!routeQuery" hasMore :hasHeader="false">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="110px">
					<el-form-item label="页面名称：" prop="pageName">
						<el-input size="small" v-model="searchForm.pageName" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="应用项目：" prop="applySys">
						<el-select v-model="searchForm.applySys" size="small">
							<el-option v-for="(item, index) in yyxm" :key="index" :label="item.sname" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="状态：" prop="sname">
						<el-select v-model="searchForm.status" placeholder="请选择">
							<el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建人：" prop="createUser">
						<el-select v-model="searchForm.createUser" placeholder="请选择">
							<el-option v-for="item in createUserList" :key="item" :label="item" :value="item"> </el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef2" :model="searchForm" label-width="110px">
					<el-form-item label="创建日期：" prop="dateArr">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							<!-- 合计设置： <span class="blue">{{ qyTotal }}</span> 项 -->
						</div>
						<div class="btnGroups">
							<el-button type="primary" class="ml5 btn-blue" size="mini" @click="addConfig('add')">
								新增配置
							</el-button>
						</div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<el-table
								:data="tableObj.tableData"
								border
								ref="qyTable"
								highlight-current-row
								v-loading="tableObj.loading"
								@row-click="onRowClick"
								height="100%"
							>
								<el-table-column type="index" label="序号" width="60" header-align="center" align="center"> </el-table-column>
								<el-table-column
									prop="pageName"
									label="页面名称"
									min-width="150"
									header-align="left"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="pageUse"
									label="页面用途"
									min-width="150"
									header-align="left"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column
									prop="pageEntry"
									label="页面入口"
									min-width="200"
									header-align="left"
									show-overflow-tooltip
								></el-table-column>
								<el-table-column prop="status" label="状态" min-width="100" header-align="center" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.status == 0" class="red-color">禁用</span>
										<span v-if="scope.row.status == 1">启用</span>
									</template>
								</el-table-column>
								<el-table-column prop="skipUrl" label="url地址" min-width="270" header-align="left" show-overflow-tooltip>
									<template slot-scope="scope">
										<span @click="copyText(scope.row)" class="color-blue">{{ scope.row.skipUrl }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="createUser" label="创建人" min-width="100" header-align="center" align="center">
								</el-table-column>
								<el-table-column prop="createDate" label="创建时间" width="165" header-align="left" align="left"></el-table-column>

								<el-table-column label="操作" align="center" min-width="220">
									<template slot-scope="scope">
										<el-button type="success" size="small" round plain class="table-btn" @click="addConfig('edit', scope.row)">
											<svg-icon icon-class="form-edit"></svg-icon> 编辑
										</el-button>
										<el-button type="primary" size="small" round plain class="table-btn" @click="addConfig('view', scope.row)">
											<svg-icon icon-class="form-look"></svg-icon> 预览
										</el-button>

										<el-switch
											class="switchStyle ml10"
											:value="scope.row.status"
											active-color="#409EFF"
											inactive-color="#dcdfe6"
											:active-value="1"
											:inactive-value="0"
											active-text="启用"
											inactive-text="禁用"
											@input="addConfig('change', scope.row)"
										>
										</el-switch>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="pageForm.current"
								:page-sizes="[10, 20, 50]"
								:page-size="pageForm.pagesize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="pageForm.total"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<div v-else class="h100">
			<detail-edit :yyxm="yyxm" :detailData="detailData"></detail-edit>
		</div>

		<!-- 配置弹窗 -->
		<el-dialog
			:visible.sync="tagsDialog.visible"
			class="primary-dialog"
			:width="tagsDialog.width"
			:title="tagsDialog.title"
			:close-on-click-modal="false"
			@closed="handleClosed"
			center
		>
			<div v-if="tagsDialog.type == 'change'">
				<div class="delClass" v-if="objectData.status == 0">
					启用后页面将允许访问
				</div>
				<div class="delClass" v-if="objectData.status == 1">
					禁后页面将禁止访问
				</div>
			</div>

			<!-- footer 组件 -->
			<div slot="footer" class="dialog-footer text-center">
				<el-button class="btn" size="small" @click="tagsDialog.visible = false" v-if="tagsDialog.type != 'add'">
					取 消
				</el-button>
				<el-button
					type="primary"
					size="small"
					class="btn btn-blue"
					:loading="btnLoading"
					v-if="tagsDialog.type == 'change'"
					@click="changeButton"
				>
					确定
				</el-button>
				<el-button type="primary" size="small" class="btn btn-blue" :loading="btnLoading" v-if="tagsDialog.type == 'del'" @click="delButton">
					确定
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import DetailEdit from './components/edit.vue'
import { Snowflake } from 'node-snowflake'
import { getDefinePageList, setPageEnableOrDisable } from 'api/modules/pageConfiguration'

export default {
	name: 'pageConfiguration',
	components: {
		DetailEdit
	},
	data() {
		return {
			qyTotal: 0,
			searchToggle: true,
			createUserList: [], //创建人列表
			statusOptions: [
				{
					value: 1,
					label: '启用'
				},
				{
					value: 0,
					label: '禁用'
				}
			],
			searchForm: {
				pageName: '',
				applySys: '',
				status: '',
				dateArr: [],
				createEndDate: '',
				createStartDate: '',
				createUser: ''
			},
			pageForm: {
				current: 1, //当前页
				pagesize: 10, //每页条数
				total: 0 //总条数
			},
			tableObj: {
				loading: false,
				tableData: [], //表格数据数组
				height: 400
			},
			yyxm: [], //应用项目
			tableShow: true,
			startDatePicker: this.beginDate(),
			endDatePicker: this.processDate(),
			tagsDialog: {
				visible: false,
				width: '740px',
				title: '',
				type: ''
			},
			btnLoading: false,
			scopeId: 0, //单选参数
			objectData: {}, //点击按钮获取的数据
			detailData: {}
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchForm')) {
				this.searchForm = JSON.parse(this.$getSessionItem('searchForm'))

				// 移除 避免污染
				this.$removeSessionItem('searchForm')
			}

			if (this.$getSessionItem('pageForm')) {
				this.pageForm = JSON.parse(this.$getSessionItem('pageForm'))

				// 移除 避免污染
				this.$removeSessionItem('pageForm')
			}
			this.getPlatFormTenants()
		}

		this.getPlatFormTenants()
	},
	methods: {
		//修改数据状态
		changeButton() {
			setPageEnableOrDisable({
				id: this.objectData.id,
				status: this.objectData.status == 0 ? 1 : 0
			})
				.then((d) => {
					if (d.operationCode == 1) {
						this.tagsDialog.visible = false
						this.tagsDialog.type = ''
						this.getPlatFormTenants()
					}
				})
				.catch((err) => {})
		},

		//查询分页数据
		getPlatFormTenants() {
			let params = Object.assign({}, this.searchForm)
			// 时间段数据处理
			params.createStartDate = params.dateArr && params.dateArr.length > 0 ? params.dateArr[0] : ''
			params.createEndDate = params.dateArr && params.dateArr.length > 0 ? params.dateArr[1] : ''

			// 分页字段
			params.current = this.pageForm.current
			params.size = this.pageForm.pagesize
			// 时间段数据处理
			this.tableObj.loading = true
			getDefinePageList(params)
				.then((d) => {
					this.pageForm.total = parseInt(d.data.baseDefinePageIpage.total)
					this.tableObj.tableData = d.data.baseDefinePageIpage.records
					this.createUserList = d.data.createUserList
					this.yyxm = d.data.applySysMap
					// this.qyTotal = parseInt(d.data.total);
					this.tableObj.loading = false
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},
		// 搜索
		searchResult() {
			this.pageForm.pagesize = 10
			this.pageForm.current = 1
			this.getPlatFormTenants()
		},

		// 条件筛选重置
		resetForm() {
			this.pageForm.pagesize = 10
			this.pageForm.current = 1
			this.searchForm.applySys = ''
			this.searchForm.dateArr = []
			this.searchForm.createStartDate = ''
			this.searchForm.createEndDate = ''
			this.searchForm.createUser = ''
			this.searchForm.status = ''
			this.searchForm.pageName = ''
			this.getPlatFormTenants()
		},
		// 每页条数改变时
		handleSizeChange(pageSize) {
			this.pageForm.pagesize = pageSize
			this.getPlatFormTenants()
		},

		// 当前页改变时
		handleCurrentChange(current) {
			this.pageForm.current = current
			this.getPlatFormTenants()
		},
		// 行点击事件
		onRowClick(row) {
			this.curRowId = row.id
		},
		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = ''
					endTime = that.searchForm.createEndDate
					if (endTime) {
						return bmElementTimeOptins.limitDateBefore(time, endTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = ''
					startTime = that.searchForm.createStartDate
					if (startTime) {
						let nowTime = Date.now()
						return bmElementTimeOptins.limitDateInRange(time, startTime, nowTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 操作按钮
		addConfig(type, item) {
			console.log(type)
			console.log('11111111111111111')
			if (type == 'add') {
				this.$router.push({
					query: {
						id: '',
						pageContent: '',
						pageName: '',
						applySys: '',
						pageEntry: '',
						type: 'add'
					}
				})
			} else if (type == 'edit') {
				this.$router.push({
					query: {
						id: item.id,
						pageContent: '',
						pageName: '',
						applySys: '',
						pageEntry: '',
						type: 'edit'
					}
				})
				this.detailData = {
					id: item.id,
					pageName: item.pageName, //页面名称
					applySys: item.applySys, //应用项目
					pageUse: item.pageUse, //页面用途
					pageEntry: item.pageEntry, //页面入口
					pageContent: item.pageContent //内容
				}
			} else if (type == 'change') {
				this.tagsDialog.title = item.status == 0 ? '是否立即启用' : '是否立即禁用'
				this.tagsDialog.width = '600px'
				this.objectData = item
				this.tagsDialog.type = type
				this.tagsDialog.visible = true
			} else if (type == 'view') {
				let url = process.env.VUE_APP_PAGE_URL + 'NgsAzcWeb/#/previewDetails/' + item.id + '/' + item.applySys
				window.open(url)
				//window.open(item.skipUrl);
			}
		},
		// 弹窗关闭
		handleClosed(needRefresh) {
			this.tagsDialog.visible = false
			this.tagsDialog.type = ''

			// 刷新
			needRefresh ? this.getPlatFormTenants() : ''
		},

		//复制文本
		copyText(item) {
			const textarea = document.createElement('textarea')
			textarea.value = item.skipUrl
			document.body.appendChild(textarea)
			textarea.select()
			document.execCommand('Copy')
			document.body.removeChild(textarea)
			this.$message.success('文本已复制到剪贴板')
		}
	},

	computed: {
		...mapState('app', {
			clientSize: (state) => state.clientSize,
			isBack: (state) => state.isBack
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		// ...mapState('dict', {
		// 	yyfw: (state) => state.yyfw

		// }),
		...mapState('dict', {
			projectDict: (state) => state.projectDict
		})
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.qyTable.doLayout()
			}, 1000)
		}
	}
}
</script>
<style lang="less" scoped>
.delClass {
	font-size: 16px;
	margin-bottom: 16px;
}
.tishi {
	font-size: 12px;
	color: #409eff;
}
.comColor {
	color: #409eff;
}
.settled-enterprises-layout {
	/deep/ .search-form {
		.el-form-item {
			margin-bottom: 5px;
		}
	}

	.settled-enterprises-head {
		padding: 10px 20px 0 20px;

		.breadcrumb-list {
			padding: 0 15px;
			border: 1px solid #ddd;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 10px;
		}

		/deep/ .el-breadcrumb__item {
			height: 35px;
			line-height: 35px;
		}

		.el-icon-location {
			color: #009900;
			font-size: 18px;
		}

		.content-head {
			padding-bottom: 20px;
		}

		.right-align {
			text-align: right;
		}
	}

	.settled-enterprises-content {
		height: calc(100% - 50px);
		padding: 0 20px;

		.content {
			height: calc(100% - 220px);
		}
	}

	.qy-number {
		display: inline-block;
		height: 30px;
		line-height: 30px;
		padding-left: 10px;
		font-size: 14px;
		border-left: 3px solid #2671cc;

		.blue {
			color: #2671cc;
			font-size: 18px;
			margin-right: 5px;
		}
	}

	.search-from {
		margin-bottom: 10px;
		border-bottom: 1px solid #2671cc;
	}

	.red {
		color: red;
	}

	.view-msg {
		color: #2671cc;
		cursor: pointer;
	}

	.ml25 {
		margin-left: 25px;
	}

	.icon {
		width: 20px;
		height: 20px;
		margin-right: 20px;
		color: #ccc;
	}

	.blue {
		color: #2671cc;
	}

	.purple {
		color: #ae5da1;
	}

	.blue-invoice {
		color: #2671cc;
	}

	.width25 {
		width: 25px;
	}

	.height25 {
		height: 25px;
	}
}

.pd0 {
	padding: 0 !important;
}
</style>

<style lang="less" scoped>
.w-table-content {
	/deep/ .el-radio__label {
		display: none;
	}
}

.label-tooltip {
	max-width: 600px;
	max-height: 140px;
	overflow-y: auto;
	overflow-x: hidden;
}

.primary-dialog {
	// /deep/ .el-dialog__body {
	//   padding: 30px;
	// }

	.row-label {
		height: 40px;
		line-height: 40px;
		padding-right: 15px;
	}

	.row-btn {
		padding-left: 10px;
		width: 100%;
	}

	.tags-container {
		line-height: 40px;
		max-height: 120px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}

	.tags-all-container {
		line-height: 30px;
		max-height: 300px;
		overflow-y: auto;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}
}

/deep/.switchStyle {
	.el-switch__label {
		position: absolute;
		display: none;
		color: #fff;
		span {
			font-size: 11px !important;
		}
	}
	.el-switch__label--left {
		z-index: 9;
		left: 6px;
	}
	.el-switch__label--right {
		z-index: 9;
		left: -9px;
	}
	.el-switch__label.is-active {
		display: block;
	}
	.el-switch,
	.el-switch__core,
	.el-switch,
	.el-switch__label {
		width: 53px !important;
	}
}

/deep/.el-radio {
	margin-left: 0 !important;
	margin-bottom: 16px;
}
.red-color {
	color: red;
}
</style>
